import { createRouter } from '@tanstack/react-router';

import {
  NotFoundPage,
  RouteLoadingSpinner,
  SomethingWentWrong,
} from './components';
import { queryClient } from './queryClient';
import { routeTree } from './routeTree.gen';
import { defaultFeatureFlags } from './utils/featureFlags';
import { parseSearch } from './utils/parseSearch';

export const router = createRouter({
  parseSearch,
  routeTree,
  defaultPendingComponent: () => <RouteLoadingSpinner />,
  defaultErrorComponent: ({ error, reset, info }) => (
    <SomethingWentWrong error={error} reset={reset} info={info} />
  ),
  defaultNotFoundComponent: () => <NotFoundPage />,
  defaultPreload: 'intent',
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  context: {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    auth: undefined!,
    queryClient,
    featureFlags: defaultFeatureFlags,
    accountLinkingToken: null,
  },
});
